import React from 'react';
import OrderList from '../components/OrderList';

export default function PendingOrders() {
  return (
    <OrderList
      status="pending"
      title="调度待跟进工单"
      desc="客服/销售/调度生成的工单先进入本列表，由调度跟进处理，填写处理思路后流转到调度处理中工单"
    />
  );
}
